<template>
    <div class="shadow-md p-3">
      <p v-if="error" class="center text-red-500">{{ error }}</p>
      <div class="flex">
        <p>Notificacion de pedidos:</p>
        <div class="flex flex-wrap">
          <div v-for="(email, index) in emailList" :key="index">
            <span  class="flex cursor-pointer m-1 p-2 rounded-md border border-black-500 hover:text-white bg-gray-200 hover:bg-gray-500 gap-1">{{ email }} <p @click="borrarMail(index)" class="rounded-md hover:bg-red-500 hover:text-white px-2">X</p></span>
          </div>
        </div>
      </div>
      <div class="flex justify-center gap-2 mx-48">
        <input placeholder="Nuevo Mail" type="text" v-model="newMail" class="form-control">
        <button @click="nuevoMail" class="btn btn-sm btn-success">Guardar</button>
      </div>
      <div class="flex gap-3 mt-3">
        <RouterLink to="/inventario/A5T5dH56TDV4f" target="_blank" class="btn btn-danger btn-sm">Catalogo con precio</RouterLink>
        <RouterLink to="/inventario/j9PqXr3yZs7Vw2" target="_blank" class="btn btn-danger btn-sm">Catalogo sin precio</RouterLink>
      </div>
      <div>
        <div class="flex gap-2 mt-2" @click="mostrarUsuarios = !mostrarUsuarios">
          <p>Usuarios no Habilitados: </p>
          <div :class="{'arrow': mostrarUsuarios}">&#9650;</div>
        </div>
        <div>
            <div v-show="mostrarUsuarios" class="h-64 overflow-y-scroll">
              <table class="table table-striped table-sm text-sm">
                <thead>
                  <tr>
                    <th scope="col">Opciones</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Email</th>
                    <th scope="col">CUIT</th>
                    <th scope="col">Razon Social</th>
                    <th scope="col">Fecha Alta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, key) in usuarios" class="px-0" :key="key">
                    <td>
                      <button @click="editarUsuario(key)" class="w-7 mr-1"><img src="../assets/icons/pencil.png" alt="Editar" title="Editar"></button>
                    </td>
                    <td>{{ user.NOMBRE_USU }}</td>
                    <td>{{ user.EMAIL_USU }}</td>
                    <td>{{ user.CUIT_USU }}</td>
                    <td>{{ user.RAZON_SOCIAL_USU }}</td>
                    <td>{{ formatFecha(user.FECHA_ALTA_USU) }}</td>
                  </tr>
                  <tr v-if="usuarios.length == 0">
                    <td>No se encontraron usuarios con ese criterio de busqueda</td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
      </div>
      <div>
        <div class="flex gap-2 mt-2" @click="mostrarPedidos = !mostrarPedidos">
          <p>Pedidos de usuarios nuevos: </p>
          <div :class="{'arrow': mostrarPedidos}">&#9650;</div>
        </div>
        <div v-show="mostrarPedidos" class="h-[60vh] overflow-y-scroll">
          <table class="table table-striped table-sm text-sm">
            <thead>
              <tr>
                <th scope="col">Editar</th>
                <th scope="col">Razon social</th>
                <th scope="col">Nombre</th>
                <th scope="col">Mail</th>
                <th scope="col">Cuit</th>
                <th scope="col">Fecha</th>
                <th scope="col">Cant. items</th>
                <th scope="col">Ver</th>
                <th scope="col">Devolver</th>
                <th scope="col">Borrar</th>
              </tr>
            </thead>
            <tbody v-if="pedidos.length > 0">
              <tr v-for="(ped, key) in pedidos" class="px-0" :key="key">
                <td>
                  <button @click="editarUsuario2(key)" class="w-7 mr-1"><img src="../assets/icons/pencil.png" alt="Editar" title="Editar"></button>
                </td>
                <td>{{ ped.razon }}</td>
                <td>{{ ped.nombre }}</td>
                <td>{{ ped.email }}</td>
                <td>{{ ped.cuit }}</td>
                <td>{{ formatFechaPed(ped.fecha) }}</td>
                <!-- <td>{{ ped }}</td> -->
                <td>{{ ped.articulos.length }}</td>
                <td><button class="btn btn-outline-primary btn-sm" @click="verItems(ped.articulos)">Ver Items</button></td>
                <td><button class="btn btn-outline-warning btn-sm" :disabled="cargando" @click="devolverCarrito(ped.id, ped.idcli)">Devolver</button></td>
                <td><input type="checkbox" v-model="ped.borrar"><button :disabled="!ped.borrar" @click="borrarPed(ped)" class="btn btn-sm btn-danger">Borrar</button></td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td>No hay pedidos aun..</td>
              </tr>
            </tbody>
          </table>
        </div>



        <div class="modal" id="itemsPed">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              
              <!-- Modal Header -->
              <div class="modal-header">
                  <h4 class="modal-title">Items del pedido</h4>
              </div>

              <p v-if="items.length && items[0].obs.includes('|')">Observacion: {{ items[0].obs.split('|')[1] }}</p>
              
              <!-- Modal body -->
              <div class="modal-body">
                <table class="table table-striped table-sm text-sm">
                  <thead>
                    <tr>
                      <th scope="col">Codigo</th>
                      <th scope="col">Descripcion</th>
                      <th scope="col">Precio unitario</th>
                      <th scope="col">cantidad</th>
                      <th scope="col">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in items" class="px-0" :key="key">
                      <td>{{ item.CODIGO_ART }}</td>
                      <td>{{ item.DESCRIP_ART }}</td>
                      <td>${{ item.PRECIO_LPI.toFixed(2) }}</td>
                      <td>{{ item.cantidad }}</td>
                      <td>${{ (Number(item.PRECIO_LPI) * Number(item.cantidad)).toFixed(2) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            
              <!-- Modal footer -->
              <div class="modal-footer">
                  <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cancelar</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
import configService from '@/services/config.service';
import pedidosService from '@/services/pedidos.service';
import usuarioService from '@/services/usuario.service';

  export default {
    data() {
      return {
        error: '',
        emailList: [],
        newMail: '',
        usuarios: [],
        pedidos: [],
        mostrarUsuarios: true,
        mostrarPedidos: true,
        items: [],
        cargando: false
      };
    },
    mounted() {
      this.inicio()
    },
    methods: {
      devolverCarrito(idusu, idcli) {
        if (confirm('¿Está seguro que desea devolver este carrito?')) {
          this.cargando = true
          pedidosService.devolverCarrito(idusu, idcli)
            .then(() => {
              this.$root.alertSuccess = true
              this.$root.isAlertVisible = true
              this.getPedidos()
            })
            .catch((err) => {
              console.log(err)
              this.$root.alertSuccess = false
              this.$root.isAlertVisible = true
            })
            .finally(() => this.cargando = false)
        }
      },
      borrarPed(ped) {
        this.cargando = true
        pedidosService.deleteCarritoUsuCli(ped.id, ped.idcli)
          .then(() => {
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
            this.getPedidos()
          })
          .catch((err) => console.log(err))
          .finally(() => this.cargando = false)
      },
      formatFechaPed(fecha) {
        const inputDateString = fecha;
        const [year, month, day] = inputDateString.split("-");
        return `${day}/${month}/${year}`;
      },
      verItems(items) {
        this.items = items
        window.$('#itemsPed').modal('show')
      },
      getPedidos() {
        this.pedidos = []
        pedidosService.getPedidosUsuariosNuevos()
            .then((res) => {
                console.log(res.data)
                this.pedidos = res.data
                this.pedidos.forEach(p => p.borrar = false)
            })
            .catch((err) => {
                console.log(err)
            })
      },
      formatDate(dateString) {
          const date = new Date(dateString);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
      },
      inicio() {
        configService.getNotifPed()
          .then((res) => {
            if (res.data) {
              this.emailList = res.data.split(';').map(email => email.trim());
            } else {
              this.emailList = []
            }
          })
          .catch((err) => {
            console.log(err)
          })
        usuarioService.getClientesNoHabilitados()
          .then(res => {
            this.usuarios = res.data
          })
          .catch(err => {
            console.log(err)
          })
        this.getPedidos()
      },
      borrarMail(index) {
        console.log(this.emailList[index])
        this.emailList.splice(index, 1);
        this.guardarNotif()
      },
      editarUsuario(key) {
        var idusu = this.usuarios[key].ID_USU
        this.$router.push('/admin/usuarios?idusu=' + idusu)
      },
      editarUsuario2(key) {
        var idusu = this.pedidos[key].id
        this.$router.push('/admin/usuarios?idusu=' + idusu)
      },
      formatFecha(fecha) {
        // var splited = fecha.split('-')
        // var fechaFormated = splited[2] + '/' + splited[1] + '/' + splited[0]
        // return fechaFormated
        var today = new Date(fecha)
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const formattedToday = dd + '/' + mm + '/' + yyyy;
        return formattedToday
      },
      guardarNotif() {
        configService.putNotifPed(this.emailList.join(';'))
          .then(() => {
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
          })
          .catch((err) => {
            console.log(err)
            this.$root.alertSuccess = false
            this.$root.isAlertVisible = true
          })
      },
      nuevoMail() {
        if (this.newMail && this.isValidEmail(this.newMail) && !this.newMail.includes(' ')) {
          console.log(1)
          this.error = ''
          this.emailList.push(this.newMail)
          this.newMail = ''
          this.guardarNotif()
        } else if (this.newMail) {
          console.log(2)
          this.error = 'El email no es valido o contiene espacios'
        }
      },
      isValidEmail(email) {
        console.log(email)
        // Check if the email contains "@" and "."
        return (email.includes("@") && email.includes("."))
      }
    },
    computed: {
    },
  };
  </script>

<style>
.arrow {
  transform: rotate(180deg);
}
</style>